import { Typography } from '@mui/material';

import { Spinner } from '../ui/spinner';

import { AcFullScreenLoaderProps } from './AcFullScreenLoader.types';

import './style.scss';

const AcFullScreenLoader = ({
  text,
  spinnerColor,
  textColor
}: AcFullScreenLoaderProps) => {
  return (
    <div className="ac-full-screen-loader">
      <Spinner className="size-10" color={spinnerColor || '#FFFFFF'} />
      <Typography sx={{ color: textColor || '#FFFFFF' }}>
        {text || 'Loading'}
      </Typography>
    </div>
  );
};

export default AcFullScreenLoader;
